import { startCase } from 'lodash';
import {
  PanelBar,
  PanelBarItem,
  PanelBarSelectEventArguments
} from '@progress/kendo-react-layout';
import {
  MultiSelect,
  MultiSelectChangeEvent
} from '@progress/kendo-react-dropdowns';
import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { ArgumentItem } from '../../types/selection-item';

export interface ArgumentSelectorProps {
  list: string;
  minimumSelected: number;
  argumentList: ArgumentItem[];
  onArgumentSelected: Function;
  selectedArgument?: ArgumentItem[];
}

export const MultipleArgumentSelector = ({
  ...props
}: ArgumentSelectorProps) => {
  const [originalValues, setOriginalValues] = useState<ArgumentItem[]>(
    props.selectedArgument ?? []
  );

  const [values, setValues] = useState<ArgumentItem[]>(
    props.selectedArgument ?? []
  );

  useEffect(() => {
    setValues(props.selectedArgument ?? []);
    setOriginalValues(props.selectedArgument ?? []);
  }, [props.selectedArgument]);

  const [expanded, setExpanded] = useState<string[]>([]);

  const onChangeFilterHandler = (e: MultiSelectChangeEvent) => {
    setValues(e.target.value);
  };

  const onSaveHandler = () => {
    if (values?.length < props?.minimumSelected) return;
    props.onArgumentSelected(values);
    setExpanded([]);
  };

  const onCancelHandler = () => {
    props.onArgumentSelected(originalValues);
    setExpanded([]);
  };

  const handleSelect = (event: PanelBarSelectEventArguments) => {
    if (event.expandedItems) {
      setExpanded(event.expandedItems);
    }
  };

  const title = React.useMemo(() => {
    if (props.list.includes('task')) return 'task';
    return props.list;
  }, [props.list]);

  React.useEffect(() => {
    if (props.argumentList.length > 0) {
      props.argumentList.sort((a, b) => {
        if (a.description && b.description) {
          if (a.description < b.description) return -1;
          if (a.description > b.description) return 1;
        }
        return 0;
      });
    }
  }, [props.argumentList]);

  return (
    <PanelBar
      expandMode={'single'}
      isControlled={true}
      expanded={expanded}
      onSelect={handleSelect}>
      <PanelBarItem title={`${startCase(title)} selector`}>
        <Row className={'p-2'}>
          <Col>
            <MultiSelect
              className={'multi-select cursor-pointer text-decoration-none'}
              textField={'title'}
              data={props.argumentList}
              placeholder={`Select ${title}s`}
              value={values}
              onChange={onChangeFilterHandler}
            />
          </Col>
        </Row>
        {values?.length < props.minimumSelected && (
          <Row className={'p-2'}>
            <Col>
              <code>{`Please select minimum ${props?.minimumSelected} ${title}${props?.minimumSelected > 1 ? 's' : ''}`}</code>
            </Col>
          </Row>
        )}

        <Row>
          <Col className={'d-flex justify-content-end'}>
            <span
              onClick={onCancelHandler}
              className={
                'material-symbols-outlined text-danger mr-1 p-2 cursor-pointer'
              }>
              close
            </span>
            <span
              onClick={onSaveHandler}
              className={
                'material-symbols-outlined text-success ml-1 p-2 cursor-pointer'
              }>
              check
            </span>
          </Col>
        </Row>
      </PanelBarItem>
    </PanelBar>
  );
};
